import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private readonly MIN_LOADING_TIME = 2000; // 2 segundos en milisegundos
  private loadingStartTime: number = 0;

  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (this.totalRequests === 0) {
      this.loadingStartTime = Date.now();
      this.loadingService.show();
    }
    this.totalRequests++;

    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          const currentTime = Date.now();
          const elapsedTime = currentTime - this.loadingStartTime;
          const remainingTime = Math.max(0, this.MIN_LOADING_TIME - elapsedTime);

          setTimeout(() => {
            this.loadingService.hide();
          }, remainingTime);
        }
      })
    );
  }
}